import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import * as CONFIG from "./_config";
import ls from "local-storage";

const axios = require("axios");

class SimpleSlider extends Component {
  render() {
    function SampleNextArrow(props) {
      const { className, style, onClick } = props;
      return (
        <div
          className={className}
          style={{ ...style, display: "block" }}
          onClick={onClick}
        />
      );
    }

    function SamplePrevArrow(props) {
      const { className, style, onClick } = props;
      return (
        <div
          className={className}
          style={{ ...style, display: "block" }}
          onClick={onClick}
        />
      );
    }

    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
    };
    return (
      <div>
        <h2> {this.props.name} </h2>
        <Slider {...settings}>
          {this.props.sliders.map((value, index) => (
            <div key={index}>
              <div>
                <img
                  loading="lazy"
                  style={{ height: "900px", margin: "auto" }}
                  src={value.URL}
                  alt="Catering Menu"
                  className="img-response"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    );
  }
}

class CateringClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      weeklyadsbuid: [],
      adsid: "",
    };
  }
  componentDidUpdate(prevProps, prevState) {
    // console.log('this',this.props);
    // console.log('prevProps',prevProps);
    if (this.props.location.pathname !== prevProps.location.pathname) {
      // console.log('route changes1');
      this.Weeklyadsbuid();
      ls.set("redirectTo", window.location.href);
    }
  }

  componentDidMount() {
    // console.log('route changes2');
    this.Weeklyadsbuid();
    ls.set("redirectTo", window.location.href);
  }

  Weeklyadsbuid = () => {
    this.setState({ weeklyadsbuid: [] });

    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : CONFIG.DATA.GUEST_TOKEN;
    var ClientStoreId = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).ClientStoreId
      : "1";

    const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/WeeklyAdGallery/${UserToken}/${ClientStoreId}`;

    axios
      .get(apiurl, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        setTimeout(() => {
          if (res.data.GalleryItems)
            this.setState({ weeklyadsbuid: res.data.GalleryItems });
        }, 900);
      })
      .catch(function (response) {
        console.log(response);
      });
  };

  render() {
    const weeklyadsbuid = this.state.weeklyadsbuid;
    return (
      <div>
        <div className="main-container default-page pt-5 mt-5  ">
          <div className="title-breadcrumb">
            <div className="container">
              <header className="entry-header">
                <h1 className="entry-title">Catering</h1>
              </header>
              <div className="breadcrumbs">
                <a href="/">Home</a>
                <span className="separator">/</span>
                <a href="/catering" title="Catering">
                  Catering
                </a>
              </div>
            </div>
          </div>
          <div className="clearfix"></div>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <p>&nbsp;</p>
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    textAlign: "left",
                  }}
                >
                  <span>Catering Menu</span>
                </p>
                <p
                  style={{
                    fontWeight: "normal",
                    textAlign: "left",
                    color: "#000",
                  }}
                >
                  Make your gathering easier by letting us take care of the
                  cooking. We are offering a variety of prepared meals that will
                  impress your family and friends. Browser the catering menu
                  below and then visit your neighborhood{" "}
                  {CONFIG.DATA.RSA_CLIENT_APP_NAME} to place your order. All
                  orders must be placed with at least a 48-hour notice.
                </p>
                <p style={{ textAlign: "left" }}>
                  <Link>
                    Click here to download our catering menu in pdf format
                  </Link>
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <figure className="thumnail" style={{ minHeight: 500 }}>
                  {weeklyadsbuid.length > 0 ? (
                    <SimpleSlider sliders={weeklyadsbuid} />
                  ) : (
                    <div className="content">
                      <div className="overlay">
                        <div className="overlay-content">
                          <img
                            loading="lazy"
                            style={{ maxWidth: "none" }}
                            src="/assets/images/loading.gif"
                            alt="Loading..."
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const Catering = withRouter(CateringClass);
export default Catering;
